import React from 'react';
import { Section } from './Section';
import { ShieldCheckIcon } from 'lucide-react';
export const Guarantee = () => {
  return <Section className="bg-stone-50 pb-8" data-id="element-103">
      <div className="max-w-3xl mx-auto bg-white border-2 border-brand-100 rounded-3xl p-8 md:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-104">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-500" data-id="element-105"></div>

        <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-50 text-brand-600 rounded-full mb-6" data-id="element-106">
          <ShieldCheckIcon className="w-10 h-10" data-id="element-107" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4" data-id="element-108">
          Garantía Total de 7 Días
        </h2>
        <p className="text-lg text-stone-600 leading-relaxed mb-0" data-id="element-109">
          Estamos tan seguros de que estas recetas te van a encantar que te
          damos <strong data-id="element-110">7 días enteros</strong> para revisar todo el material.
          Si sientes que no es para ti, o simplemente no te gustan las recetas,
          nos envías un correo y te devolvemos el 100% de tu dinero.{' '}
          <strong data-id="element-111">Riesgo cero para ti.</strong>
        </p>
      </div>
    </Section>;
};